import * as React from 'react'
import * as style from './index.module.css'

interface Props {
  /** カテゴリー */
  readonly category: string
}

/**
 * @file カテゴリー
 *
 * @param {string} category - カテゴリー
 */
export const Category = ({ category }: Props): React.JSX.Element => (
  <div className={style.root}>{category}</div>
)
